import React, { useState, useEffect } from "react";
import { Calendar, momentLocalizer, Views } from "react-big-calendar";
import Moment from "moment";
import { extendMoment } from "moment-range";
import CalenderWrapper from "./Calender.style";
import withDragAndDrop from "react-big-calendar/lib/addons/dragAndDrop";
import "react-big-calendar/lib/addons/dragAndDrop/styles.css";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { Typography, Button } from "antd";
import CalenderEventDetails from "./CalenderEventDetails";
import { CloseOutlined } from "@ant-design/icons";
import { useIntl } from "react-intl";
import { convertAvailabilityEventsToCalender } from "../util/helpers";
const { Title } = Typography;
const DragAndDropCalendar = withDragAndDrop(Calendar);
const moment = extendMoment(Moment);
const localizer = momentLocalizer(moment);

const CalenderPicker = (props) => {
  const { record, comp, onFinish, title, onDecline } = props;
  const [activeEvent, setActiveEvent] = useState(null);
  const [events, setEvents] = useState([]);
  const displayDragItemInCell = true;
  const localeLang = "he";
  const [draggedEvent, setDraggedEvent] = useState(null);
  const intl = useIntl();

  useEffect(() => {
    const converted = convertAvailabilityEventsToCalender(record);
    setEvents(converted);
  }, [record]);

  const handleDragStart = (event) => {
    setDraggedEvent(event);
  };

  const dragFromOutsideItem = () => {
    return draggedEvent;
  };

  const onDropFromOutside = ({ start, end, allDay }) => {
    const event = {
      id: draggedEvent.id,
      title: draggedEvent.title,
      start,
      end,
      // allDay: allDay,
    };
    setDraggedEvent(null);
    moveEvent({ event, start, end });
  };

  const moveEvent = ({ event, start, end }) => {
    changeEvent(event, start, end);
  };

  const resizeEvent = ({ event, start, end }) => {
    changeEvent(event, start, end);
  };

  const onDoubleClickEvent = (event) => {
    editEvent(event);
  };

  const changeEvent = (changed, start, end) => {
    const changedEvent = {
      ...changed,
      start,
      end,
    };
    const isDistinct = !isOverlapping(changedEvent);
    if (isDistinct) {
      const converted = changedEvent;
      const nextEvents = events.map((existingEvent) => {
        return existingEvent.id === converted.id ? converted : existingEvent;
      });
      setActiveEvent(converted);
      setEvents(nextEvents);
    }
  };

  const createEvent = (newEvent) => {
    const isDistinct = !isOverlapping(newEvent);
    if (isDistinct) {
      newEvent["id"] = events.length + 1;
      const converted = newEvent;
      setActiveEvent(converted);
      setEvents([...events, { ...converted }]);
    }
  };

  const editEvent = (newEvent) => {
    const converted = newEvent;
    setActiveEvent(converted);
  };

  const removeEvent = () => {
    const nextEvents = activeEvent
      ? events.filter((item) => item.id !== activeEvent.id)
      : events;
    setEvents(nextEvents);
    setActiveEvent(null);
  };

  const onSubmit = () => {
    onFinish(events);
  };

  const isOverlapping = (newEvent) => {
    let overlapping = false;
    const filtered = events.filter((i) => i.id !== newEvent.id);
    filtered.forEach((item, i) => {
      const range1 = moment.range(newEvent.start, newEvent.end);
      const range2 = moment.range(item.start, item.end);
      if (range1.overlaps(range2, { adjacent: false })) {
        overlapping = true;
      }
    });
    return overlapping;
  };

  let formats = {
    dayFormat: "dddd",
  };
  var startOfWeek = moment().startOf("week").toDate();
  var scrollTime = moment(startOfWeek).add(6, "hours").toDate(); // see the cloning?
  return (
    <CalenderWrapper>
      <Button
        style={{ position: "absolute", right: 10, top: 10 }}
        className="closeBtn"
        type="text"
        shape="circle"
        icon={<CloseOutlined />}
        onClick={onDecline}
      />
      <Button
        style={{ position: "absolute", left: 20, top: 20 }}
        type="primary"
        onClick={onSubmit}
        size="large"
      >
        {intl.formatMessage({
          id: "app.actions.submit",
        })}
      </Button>
      <Title
        style={{
          fontSize: "30px",
          fontWeight: 500,
          lineHeight: 1.27,
          color: "rgba(0, 0, 0, 0.85)",
          margin: "13px 0 40px 0 ",
          textAlign: "center",
        }}
      >
        {title}
      </Title>
      <div className="calenderContainer">
        <CalenderEventDetails
          onChange={changeEvent}
          activeEvent={activeEvent}
          onRemove={removeEvent}
          comp={comp}
        />

        <DragAndDropCalendar
          popup
          formats={formats}
          rtl={localeLang === "he"}
          toolbar={false}
          selectable
          step={15}
          localizer={localizer}
          events={events}
          defaultView={Views.WEEK}
          defaultDate={startOfWeek}
          scrollToTime={scrollTime}
          onEventDrop={moveEvent}
          resizable
          onEventResize={resizeEvent}
          onSelectSlot={createEvent}
          onSelectEvent={editEvent}
          onDoubleClickEvent={onDoubleClickEvent}
          dragFromOutsideItem={
            displayDragItemInCell ? dragFromOutsideItem : null
          }
          onDropFromOutside={onDropFromOutside}
          handleDragStart={handleDragStart}
          style={{ height: "100%", width: "100%" }}
        />
      </div>
    </CalenderWrapper>
  );
};

export default CalenderPicker;
